module.exports = __webpack_public_path__ + "static/media/land-drawer-img--water.bd40642c.png";